export const calculatePercentageDiscount = (
  originalPrice: number,
  percentageAmount: number,
) => {
  if (percentageAmount <= 0) return 0;

  if (percentageAmount >= 100) return originalPrice;

  // note rounding down does not cause any issues with calculations in practice as all values are in pence so numbers are large
  return Math.floor(originalPrice * (percentageAmount / 100));
};
